export default "__VITE_ASSET__uXK_Z83A__"